import {HabiHostMaps, getHost} from '@xc/hiya-host'
import {isNode} from '../index'

export const isProd = ENV === 'production'

export const AutoHost = (() => {
  let host: string
  if (!isNode()) {
    host = window.location.host
  }
  return getHost({
    HostMaps: {
      ...HabiHostMaps,
      test: [
        ...HabiHostMaps.test,
        {
          'me-live-websit': 'h5-hiya-test.test.com',
          'hiya-web': 'hiya-web-test.test.com',
          activity: 'activity-hiya-web-test.test.com',
          version: 'version-hiya-web-test.test.com',
          //
          static: 'static-hiya-test.test.com',
          'other-static': 'static-hiya-web.mehiya.com',
          //
          img01: 'me-media-gateway.test03.test.com',
          video01: 'video01.srv.test.ixiaochuan.cn',
          api: 'api-hiya-test.test.com',
        },
      ],
    },
    env: isProd ? 'prod' : 'test',
    host,
  })
})()
export const {
  auto,
  prod,
  replaceAutoHost,
  replaceAutoHostBgImg,
  replaceAutoHostStyle,
} = AutoHost
export const HostMaps = {
  auto: {
    websit: isProd
      ? `https://${auto['me-live-websit']}`
      : `http://${auto['me-live-websit']}`,
    web: isProd ? `https://${auto['hiya-web']}` : `http://${auto['hiya-web']}`,
    activity: isProd ? `https://${auto.activity}` : `http://${auto.activity}`,
    version: isProd ? `https://${auto.version}` : `http://${auto.version}`,
    img01: `http://${auto.img01}`,
    video01: `http://${auto.video01}`,
    otherStatic: `https://${auto['other-static']}`,
    api: isProd ? `https://${auto.api}` : `http://${auto.api}`,
  },
  prod: {
    activity: `https://${prod.activity}`,
    version: `https://${prod.version}`,
    video01: `http://${prod.video01}`,
    img01: `http://${prod.img01}`,
    api: `https://${prod.api}`,
  },
}
